import { Plane, Hotel, Calendar, Utensils, Info, ListCheck } from 'lucide-react';

export default function TimelineView({ itinerary, pageTheme }) {

  const {
      packageTrendsPageBackground,
      packageTrendsPageCardBackground,
      packageTrendsPagePrimaryColor,
      packageTrendsPageSecondColor,
      packageTrendsPageThirdColor,
      packageTrendsPageFourthColor,
  } = pageTheme;

  const getDayProducts = (date) => {
    return itinerary.products.flatMap(p => 
      p.items.filter(item => item.date === date).map(item => ({ ...item, type: p.product_type }))
    );
  };

  return (
    <div className="max-w-5xl mx-auto px-6 py-12">
      <div className="mb-12">
        <h2 className="text-3xl font-bold text-gray-900 mb-4 font-serif">{itinerary.description_section_title}</h2>
        <p className="text-gray-600 leading-relaxed max-w-3xl">
          {itinerary.description}
        </p>
      </div>

      <div className="space-y-16">
        {itinerary.trip_days.map((day, index) => {
          const dayProducts = getDayProducts(day.date);
          
          return (
            <div
              key={day.number}
              style={{borderLeft: ("2px solid "+packageTrendsPagePrimaryColor+"33")}}
              className="relative pl-8 md:pl-12 border-l-2 border-gray-100"
            >
              {/* Timeline dot */}
              <div style={{border: "4px solid white", boxShadow: "1px 1px 4px rgba(0,0,0,0.2)"}} className={`absolute -left-[9px] top-0 w-4 h-4 rounded-full bg-[${packageTrendsPagePrimaryColor}] border-4 border-white shadow-sm`} />
              
              <div className="flex flex-col md:flex-row md:items-start gap-6">
                <div className="md:w-1/4">
                  <p className={`text-[${packageTrendsPagePrimaryColor}] font-bold uppercase tracking-widest text-sm mb-1`}>
                    {day.title}
                  </p>
                  <p className="text-2xl font-bold text-gray-900 mb-2">
                    {new Date(day.date).toLocaleDateString('en-US', { month: 'long', day: 'numeric' })}
                  </p>
                  {day.meals.length > 0 && (
                    <div className="flex flex-wrap gap-2 mt-4">
                      {day.meals.map(meal => (
                        <span style={{border: "1px solid rgba(0,0,0,0.05)"}}
                          key={meal} className="flex items-center gap-1 px-2 py-1 rounded-md bg-gray-50 text-gray-500 text-xs font-medium border border-gray-100">
                          <Utensils className="w-3 h-3" />
                          {meal}
                        </span>
                      ))}
                    </div>
                  )}
                </div>

                <div className="md:w-3/4 space-y-6">
                  <div className="bg-white p-6 rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
                    <p className="text-gray-600 leading-relaxed italic">
                      "{day.description}"
                    </p>
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    {dayProducts.map((item, i) => (
                      <div 
                        key={i}
                        style={{border: "1px solid rgba(0,0,0,0.05)"}}
                        className="p-4 rounded-xl bg-slate-50 flex items-start gap-4"
                      >
                        <div className={`p-2 rounded-lg ${
                          item.type === 'flight' ? 'bg-blue-100 text-blue-600' :
                          item.type === 'hotel' ? 'bg-purple-100 text-purple-600' :
                          `bg-[${(packageTrendsPagePrimaryColor+"1A")}] text-[${packageTrendsPagePrimaryColor}]`
                        }`}>
                          {
                            item.type === 'flight' ? <Plane className="w-5 h-5" /> :
                            item.type === 'hotel' ? <Hotel className="w-5 h-5" /> :
                            item.type === 'event' ? <Calendar className="w-5 h-5" /> :
                            <ListCheck className="w-6 h-6" />
                          }
                        </div>
                        <div>
                          <p className="text-xs font-bold uppercase tracking-wider text-gray-400 mb-1">
                            {item.type}
                          </p>
                          <p className="font-bold text-gray-900">
                            {item.name || item.topic || `${item.departure_airport} → ${item.arrival_airport}`}
                          </p>
                          <p className="text-sm text-gray-500">
                            {item.departs || item.time || item.checkin_time}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
